export var NO_RETRIES = [];
export var UP_TO_TWO_INSTANT_RETRIES = [0, 0];
export var DEFAULT_RETRIES = [0, 50, 100];
export var LAZY_LOAD_RETRIES = [100, 500, 1000];